import { useEffect } from 'react';
import { navigate } from "@reach/router"

const AerialLiftsPage = () => {
  useEffect(() => {
    navigate('/solutions/use-cases/routine-inspections/');
  }, []);
  return null;
};

export default AerialLiftsPage;